type tech = {
  name: string;
  icon: string;
};

type project = {
  name: string;
  description: string;
  image: string;
  github: string;
  url: string;
  tech: tech[];
  fullDescription: string;
};

const data: project[] = [
  {
    name: "YouTube Clone",
    description: "A YouTube clone created with the original YouTube API",
    image: "https://i.postimg.cc/gL62f65f/Capture.png",
    github: "https://github.com/asifurrahaman754/youtube-clone",
    url: "https://yt-clone754.netlify.app/",
    tech: [
      {
        name: "React",
        icon: "assets/img/React.png",
      },
      {
        name: "Redux",
        icon: "assets/img/redux.png",
      },
      {
        name: "Materia UI",
        icon: "assets/img/material-ui.png",
      },
      {
        name: "Youtube API",
        icon: "assets/img/api.png",
      },
    ],
    fullDescription: "A YouTube clone created with the original YouTube API",
  },
  {
    name: "Library Management System",
    description:
      "A fully functioning Library Management System to manage books and users.",
    image: "https://i.postimg.cc/14B568zh/lib3.png",
    github: "https://github.com/asifurrahaman754/library-management",
    url: "http://libassista.rf.gd/",
    tech: [
      {
        name: "HTML",
        icon: "assets/img/HTML5.png",
      },
      {
        name: "CSS",
        icon: "assets/img/CSS3.png",
      },
      {
        name: "Boostrap",
        icon: "assets/img/Bootstrap.png",
      },
      {
        name: "PHP",
        icon: "assets/img/PHP.jpg",
      },
      {
        name: "MySQL",
        icon: "assets/img/MySQL.png",
      },
    ],
    fullDescription:
      "This is a fully responsive and dynamic Library Management System where a user can manage his library. A person/admin can create new books and manage books in different locations, manage fines, approve/cancel the book issue, manage the listed users, etc. On the other hand, a person/user/student can create a new account for the library and search for their favorite book. If he finds it then he/she can issue the book. Some of the screenshot from the web app is listed below",
  },
  {
    name: "Covid Tracker",
    description: "A Covid Tracker app to track the worldwide covid data.",
    image: "https://i.postimg.cc/qz241q5C/Capture.png",
    github: "https://github.com/asifurrahaman754/covid-tracker-v2.0",
    url: "https://covid-tracker754.netlify.app/",
    tech: [
      {
        name: "React",
        icon: "assets/img/React.png",
      },
      {
        name: "SASS",
        icon: "assets/img/sass.png",
      },
      {
        name: "Boostrap",
        icon: "assets/img/Bootstrap.png",
      },
      {
        name: "Firebase",
        icon: "assets/img/firebase.png",
      },
    ],
    fullDescription: "A Covid Tracker app to track the worldwide covid data.",
  },
  {
    name: "Color Generator",
    description:
      "This app generates eight random color scemes, which you can use in your project.",
    image:
      "https://i.postimg.cc/DSyjM2QS/colorgenerator.png' border='0' alt='colorgenerator",
    github: "https://github.com/asifurrahaman754/color-generator",
    url: "https://asifurrahaman754.github.io/color-generator/",
    tech: [
      {
        name: "HTML",
        icon: "assets/img/HTML5.png",
      },
      {
        name: "CSS",
        icon: "assets/img/CSS3.png",
      },
      {
        name: "javaScipt",
        icon: "assets/img/JavaScript.jpeg",
      },
    ],
    fullDescription:
      "This app generates eight random color scemes, which you can use in your project.",
  },
];

export default data;
